import React, { Component } from 'react';
import { CardElement} from '@stripe/react-stripe-js';
import { Button, Form, Alert } from 'react-bootstrap';
import './PaymentMethod.css';

class PaymentMethod extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      processing: false,
      name: '',
      expiryMonth: '',
      expiryYear: '',
      cvc: '',
    };
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({ processing: true });

    const { stripe, elements } = this.props;
    const cardElement = elements.getElement(CardElement);

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
      billing_details: {
        name: this.state.name,
      },
    });

    if (error) {
      this.setState({ error: error.message, processing: false });
    } else {
      console.log('Payment Method ID:', paymentMethod.id);
      this.setState({ processing: false });
    }
  };

  handleInputChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const { error, processing, name, expiryMonth, expiryYear, cvc } = this.state;

    return (
      <div className="payment-method-wrapper">
        <div className="payment-method-container" style={{ marginTop: '90px', marginRight: '150px' }}>
          <h2 className="text-center mb-4">Méthode de Paiement</h2>
          <Form onSubmit={this.handleSubmit}>
            <Form.Group controlId="formCardDetails">
              <Form.Label>Détails de la carte</Form.Label>
              <CardElement className="card-element" />
            </Form.Group>
            <Form.Group controlId="formCardName">
              <Form.Label>Nom sur la carte</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={name}
                onChange={this.handleInputChange}
                required
                className="form-control"
              />
            </Form.Group>
            <div className="row">
              <div className="col-md-6">
                <Form.Group controlId="formExpiryMonth">
                  <Form.Label>Mois d'expiration</Form.Label>
                  <Form.Control
                    type="text"
                    name="expiryMonth"
                    value={expiryMonth}
                    onChange={this.handleInputChange}
                    placeholder="MM"
                    required
                    className="form-control"
                  />
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group controlId="formExpiryYear">
                  <Form.Label>Année d'expiration</Form.Label>
                  <Form.Control
                    type="text"
                    name="expiryYear"
                    value={expiryYear}
                    onChange={this.handleInputChange}
                    placeholder="YY"
                    required
                    className="form-control"
                  />
                </Form.Group>
              </div>
            </div>
            <Form.Group controlId="formCvc">
              <Form.Label>Cvv</Form.Label>
              <Form.Control
                type="text"
                name="cvc"
                value={cvc}
                onChange={this.handleInputChange}
                required
                className="form-control"
                placeholder="CVV"
              />
            </Form.Group>
            {error && <Alert variant="danger">{error}</Alert>}
            <Button
              type="submit"
              disabled={!this.props.stripe || processing}
              className="btn-primary btn-block"
              style={{ margin: '30px 0', marginLeft: '70px', backgroundColor: '#9caf7d' }}
            >
              {processing ? 'Traitement...' : 'Confirmer la carte'}
            </Button>
            <Button
              type="reset"
              disabled={!this.props.stripe || processing}
              className="btn-primary btn-block"
              style={{ margin: '30px ', marginLeft: '100px', backgroundColor: '#C62E2E' }}
            >
              {processing ? 'Traitement...' : 'Annuler'}
            </Button>
          </Form>
        </div>
        <img
          src={`${process.env.PUBLIC_URL}/card.png`}
          alt="Logo"
          style={{ width: '450px', height: '400', marginLeft: '200px', marginTop: '-400px' }}
        />
      </div>
    );
  }
}

export default PaymentMethod;
